<template>
	<div class="banner mb60">
		<img :src="imgSrc"/>
	</div>
</template>

<script>
	export default{
		name:'banner',
		props:{
			imgSrc:String
		}
	}
</script>

<style>
.banner{ background: #00AAFF;}
</style>


// WEBPACK FOOTER //
// src/components/banner/index.vue